import { AdminSectionPage } from "./section-page";

export function AdminSettingsPage() {
  return (
    <AdminSectionPage
      bullets={[
        "Control system-wide defaults, business metadata, and platform settings.",
        "Keep operational configuration separate from day-to-day catalog work.",
        "Prepare a home for future payment, delivery, and notification controls."
      ]}
      description="Settings should serve as the administrative control room for the platform rather than being scattered across unrelated pages."
      eyebrow="Settings"
      title="System configuration"
    />
  );
}
